import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

const routePath = [
  '/Chat/LoveJourney', // higo的七日心动之旅，hiya没有
  '/Chat/SelfFission', // higo的达人自裂变，hiya没有
]

export default routePath.map((p) => {
  return {
    path: p,
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-discontinued" */ '~/pages/Discontinued'
        )
    ),
  }
}) as RouteConfig[]
